
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate.ts";
import { HangingBookingPosSummary } from "@/domain/entities/HangingOutgoing";
import { computed, defineComponent, toRefs } from "vue";
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: "TabHangingBkdPos",
  props: {
    data: {
      type: HangingBookingPosSummary,
      default: new HangingBookingPosSummary(),
      required: true
    }
  },

  setup(props) {
    // ✅ Destructure with reactivity
    const { t } = useI18n();
    const { data } = toRefs(props);

    const cardData = computed(() => {
      const { activities, byLabel } = data.value;

      const cardStyle: { [key: string]: any } = {
        "Admin POS": {
          icon: require("@/app/ui/assets/svg/ic_pic.svg"),
          alt: "total-admin-pos",
          label: `${t("dashboard.hangingBkd.total")} <b>${t("dashboard.hangingBkd.adminPos")}</b>`
        },
        BKD: {
          icon: require("@/app/ui/assets/svg/box-bkd.svg"),
          alt: "total-stt-bkd",
          label: `${t("dashboard.hangingBkd.total")} ${t("dashboard.hangingBkd.stt")} <b>${t("dashboard.hangingBkd.bkd")}</b>`
        },
        PUP: {
          icon: require("@/app/ui/assets/svg/truck-pup.svg"),
          alt: "total-stt-pup",
          label: `${t("dashboard.hangingBkd.total")} ${t("dashboard.hangingBkd.stt")} <b>${t("dashboard.hangingBkd.pup")}</b>`
        }
      };

      const byLabelData = byLabel.map((item) => ({
        ...item,
        ...cardStyle[item.label]
      }));

      return [
        {
          icon: require("@/app/ui/assets/svg/total-active-awb-hanging.svg"),
          alt: "total-active-bkd-pos",
          label: t("dashboard.hangingBkd.totalActivity"),
          pending: activities.pending,
          done: activities.done,
          total: activities.total
        },
        ...byLabelData
      ];
    });

    // ✅ Return only what's needed in template
    return {
      cardData,
      formatDate
    };
  }
});
